import { useRef, useEffect } from 'react';
import { Bold, Italic, Underline } from 'lucide-react';

const SIZES = [
  { label: 'Piccolo', value: '2' },
  { label: 'Normale', value: '3' },
  { label: 'Grande', value: '5' },
];

// Mini editor rich-text (HTML email-safe: b/i/u/font) con toolbar B/I/U, colore e dimensione.
export const RichTextEditor = ({ value, onChange, placeholder, testId }) => {
  const ref = useRef(null);
  const savedRange = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || '')) ref.current.innerHTML = value || '';
  }, [value]);

  const saveSel = () => {
    const s = window.getSelection();
    if (s && s.rangeCount > 0 && ref.current?.contains(s.anchorNode)) savedRange.current = s.getRangeAt(0);
  };
  const restoreSel = () => {
    if (!savedRange.current) return;
    const s = window.getSelection();
    s.removeAllRanges();
    s.addRange(savedRange.current);
  };
  const exec = (cmd, arg) => {
    ref.current?.focus();
    document.execCommand(cmd, false, arg);
    onChange(ref.current.innerHTML);
  };

  const btnCls = 'h-8 w-8 inline-flex items-center justify-center border border-input bg-background hover:bg-muted text-foreground';

  return (
    <div className="border border-input">
      <div className="flex flex-wrap items-center gap-1 border-b border-input bg-muted/40 p-1.5">
        <button type="button" className={btnCls} title="Grassetto" data-testid="rte-bold"
          onMouseDown={(e) => e.preventDefault()} onClick={() => exec('bold')}>
          <Bold className="h-4 w-4" />
        </button>
        <button type="button" className={btnCls} title="Corsivo" data-testid="rte-italic"
          onMouseDown={(e) => e.preventDefault()} onClick={() => exec('italic')}>
          <Italic className="h-4 w-4" />
        </button>
        <button type="button" className={btnCls} title="Sottolineato" data-testid="rte-underline"
          onMouseDown={(e) => e.preventDefault()} onClick={() => exec('underline')}>
          <Underline className="h-4 w-4" />
        </button>
        <span className="w-px h-6 bg-border mx-1" />
        <label className={`${btnCls} cursor-pointer relative`} title="Colore testo" onMouseDown={saveSel}>
          <span className="text-sm font-bold leading-none">A</span>
          <span className="absolute bottom-1 left-1/2 -translate-x-1/2 w-4 h-1 bg-red-500" />
          <input type="color" defaultValue="#e11d48" className="absolute inset-0 opacity-0 cursor-pointer w-full h-full" data-testid="rte-color"
            onChange={(e) => { restoreSel(); exec('foreColor', e.target.value); }} />
        </label>
        <select className="h-8 border border-input bg-background text-xs px-1" title="Dimensione carattere" defaultValue="3" data-testid="rte-size"
          onMouseDown={saveSel}
          onChange={(e) => { restoreSel(); exec('fontSize', e.target.value); }}>
          {SIZES.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
        </select>
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        className="rte-editor min-h-[220px] max-h-[420px] overflow-y-auto p-3 text-sm focus:outline-none"
        data-placeholder={placeholder}
        data-testid={testId}
        onInput={(e) => onChange(e.currentTarget.innerHTML)}
        onBlur={saveSel}
      />
    </div>
  );
};
